// 中文
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'

const zh = {
  request: {
    loading: '拼命获取中',
    timeout: '请求超时',
    fail: '数据获取失败'
  },
  route: {
    dashboard: '首页'
  },
  mod_password: '修改密码',
  logout: '退出登录',
  welcome: '欢迎来到管理系统！',
  // *********按钮区***********
  search_btn: '查询',
  export_excel_btn: '导出Excel',
  mod_btn: '编辑',
  add_btn: '新增',
  cancel_btn: '取消',
  save_btn: '保存',
  confirm_btn: '确认',
  main_btn: '操作',
  day_1: '1天',
  day_3: '3天',
  day_7: '7天',
  lately_week: '最近一周',
  lately_one_month: '最近一个月',
  lately_three_month: '最近三个月',
  day_infinitely: '永久封禁',
  day: '天',
  hour: '小时',
  minute: '分钟',
  // *********常用输入限制***********
  maxlength_20: '上限20个字符',
  maxlength_50: '上限50个字符',
  // **********消息提示**********
  modify_success_message: '修改成功',
  submit_success_message: '提交成功',
  user_type: {
    name_0: '用户',
    name_1: '主播',
    name_2: '家族长'
  },
  user_new: {
    name_0: '否',
    name_1: '是'
  },
  ...zhLocale,
  user_id: '用户id',
  user_id_placeholder: '请输入用户ID',
  user_name: '昵称',
  user_name_placeholder: '请输入用户昵称',
  user_real_name: '真实姓名',
  user_phone: '手机号',
  order_by_desc_placeholder: '请选择排序方式',
  idcard: '身份证号',
  close: '关闭',
  checkAll: '全选',
  user_language_lable_option_1: '中文',
  user_language_lable_option_2: '英语',
  user_language_lable_option_3: '印尼',
  user_language_lable_option_0: '全球',
  user_language_lable_option_4: '马来语',
  user_language_lable_option_5: '阿拉伯语',
  diamond_type_option_1: '收入',
  diamond_type_option_2: '支出',
  pay_at: '交易时间',
  log_change_type: '流水类型',
  diamond_type: '交易类型',
  id_type_placeholder: '请选择',
  form_rules_required: '必填',
  rule_not_empty: '不能为空',
  rule_mobile: '请输入正确手机号',
  rule_email: '请输入正确邮箱',
  rule_start_date: '请选择开始日期',
  rule_end_date: '请选择结束日期',
  rule_date: '请选择日期',
  rule_select: '请选择一个',
  rule_number: '请输入数字值',
  rule_number_pot: '请填写数字,最多2位小数',
  rule_id_number_empty: '证件号码不能为空',
  rule_id_number_error: '证件号码不正确',
  rule_int_number: '请输入整数',
  rule_confirm_password: '两次密码输入不一致',
  rule_code: '手机验证码',
  rule_zh_mobile: '目前只支持中国大陆的手机号码',
  rule_password: '长度必须大于8位长度在 8 到 16 个字符之间',
  rule_upload_imgs: '请选择图片'
}

export default zh
